import { makeStyles } from "@material-ui/core/styles";
import { colors } from "@utils/constant";

const TableStyle = makeStyles({
  customModal: {
    "& .MuiDialog-paperWidthSm": {
      boxShadow: "0 5px 8px 0 rgba(0, 0, 0, 0.24)",
      padding: "32px 40px 40px",
      maxWidth: "820px",
      width: "100%",
      "@media (max-width: 991px)": {
        maxWidth: "100%",
        padding: "20px 15px",
        margin: "30px 15px",
        width: "auto",
      },
    },
    "& .MuiListSubheader-root.MuiListSubheader-sticky": {
      backgroundColor: "white",
    },
  },
  customTable: {
    maxHeight: 680,
    boxShadow: "none",
    "& .MuiTable-root": {
      "& .MuiTableCell-root": {
        fontWeight: 500,
        color: colors.black,
        border: "none",
        wordBreak: "break-word",
      },
      "& .MuiTableHead-root": {
        boxShadow: "0 3px 8px 0 rgba(97, 97, 97, 0.08)",
        backgroundColor: colors.white,
        "& .MuiTableCell-root": {
          color: "rgba(33, 33, 33, 0.7)",
          padding: "20px 15px",
          backgroundColor: colors.white,
          borderBottom: "1px solid #f4f4f4",
          "&:first-child": {
            paddingLeft: "30px",
          },
          "&:last-child": {
            paddingRight: "30px",
          },
        },
      },
      "& .MuiTableBody-root": {
        "& .MuiTableRow-root:hover": {
          backgroundColor: colors.lightGray,
        },
        "& .MuiTableCell-root": {
          padding: "20px 15px",
        },
      },
      "& .check-box": {
        width: "30px",
        "& .MuiIconButton-label": {
          width: "25px",
          height: "25px",
        },
        "& img": {
          borderRadius: "4px",
        }
      },
      "& .role-name": {
        width: "250px",
      },
      "& .permission": {
        width: "150px",
      },
    },
  },
  actionDropdown: {
    width: "235px",
    float: "right",
    "& .MuiSelect-select": {
      fontSize: "13px",
      lineHeight: "35px",
      borderRadius: "5px",
    },
    "&:hover:not(.Mui-disabled):before": {
      borderBottom: "0",
    },
    "&:before, &.Mui-focused:after": {
      borderBottom: "0",
    },
    "& .MuiSvgIcon-root": {
      width: "0.7em",
      height: "0.9em",
    },
  },
  actionMenuItem: {
    fontSize: "13px !important",
    lineHeight: "1",
  },
});

export { TableStyle };
